import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectIsGuest } from 'redux/db/reducers';
import * as S from './styles';

interface NavbarProps {
	children: React.ReactNode;
}

const Navbar = React.forwardRef<HTMLDivElement, NavbarProps>(({ children }, ref) => {
	const { sidebarDocked, isGuest } = useSelector((r: RootReducer) => {
		return {
			sidebarDocked: r.mode.sidebarDocked,
			isGuest: selectIsGuest(r.db),
		};
	}, shallowEqual);

	const makeSpaceForSidebar = !isGuest && !sidebarDocked;

	return (
		<S.Base ref={ref} makeSpaceForSidebar={makeSpaceForSidebar}>
			{children}
		</S.Base>
	);
});

Navbar.displayName = 'Navbar';

export default Navbar;
